export const copyToClipboard = (text: string, onSuccess?: () => void) => {
  navigator.clipboard.writeText(text).then(onSuccess)
}
export default copyToClipboard
